import OrmModeling from './modeler.js';

export default {
    __init__ : [
        'modeling'
    ],
    modeling: ['type', OrmModeling]
};